<template>
  <div class="thirdMall" :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }">
    <van-nav-bar title="省钱攻略" left-arrow @click-left="onClickLeft" />
    <div class="main">
      <img :src="imgUrl" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgUrl: "",
      isiOSX: false,
      Toast: null,
      name: "",
    };
  },
  methods: {
    //获取省钱攻略
    getData() {
      this.Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      this.$api
        .post("/third-mall/member/content/config", {})
        .then((res) => {
          this.imgUrl = res[this.name];
          this.Toast.clear();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
          this.Toast.clear();
        });
    },
    //返回
    onClickLeft() {
      this.params("", "", "goBack");
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    this.name = this.$route.query.name;
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.thirdMall {
  display: flex;
  flex-direction: column;
  background: #f5f6f7;
  height: 100%;
  box-sizing: border-box;
  .main {
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: scroll;
    flex: 1;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
<style lang="less">
.thirdMall {
  .van-nav-bar {
    background: none;
    height: 44px;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }
  }
  [class*="van-hairline"]::after {
    border-bottom: solid 1px #f5f6f7;
  }
}
</style>